import { Popconfirm, Space, Table } from "antd"

const List = ({ 
  columnTable, 
  dataList, 
  onEditEvent, 
  onDeleteEvent, 
  rowSelection, 
  expandableTable, 
  rowClassName, 
  handleChangeTable, 
  onExtendProxy,
  isLoading = false,
  isHideAction = false,
  rowKey= 'id',
}) => {
  const columns = [
    ...columnTable,
    {
      title: 'ACTION',
      key: 'action',
      fixed: 'right',
      hidden: isHideAction,
      render: (_, record) => (
        <Space size="middle">
          {onExtendProxy && <a className="py-1 px-2 border rounded-md bg-gray-200" onClick={() => onExtendProxy(record)}>Extend</a>}
          {onEditEvent && <a className="py-1 px-2 border rounded-md bg-gray-200" onClick={() => onEditEvent(record)}>Edit</a>}
          {onDeleteEvent ? <Popconfirm
            title="Delete item"
            description="Are you sure to delete this?"
            onConfirm={() => onDeleteEvent(record.id)}
            okText="Yes"
            cancelText="No"
            >
            <a style={{ color: "red" }}>Delete</a>
          </Popconfirm> : ""}
        </Space>
      ),
    },
  ]

  return <Table
    key={dataList.length}
    rowKey={rowKey}
    columns={columns}
    dataSource={dataList}
    scroll={{
      x: 'max-content',
    }}
    rowSelection={rowSelection}
    expandable={expandableTable}
    rowClassName={rowClassName}
    onChange={handleChangeTable}
    loading={isLoading}
  />
}

export default List